import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import VueI18n from 'vue-i18n';

import en from './i18n/en.json';
import zh from './i18n/zh.json';

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueI18n);

const messages = { en, zh };
const browserLang = (navigator.language || navigator.userLanguage).toLowerCase();
const locale = browserLang.includes('zh') ? 'zh' : 'en';

const i18n = new VueI18n({
    locale,
    messages
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
